import * as React from 'react';
import { Body1, Button, UIHeading1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface ICompareBannerProps {
  onClick: () => void;
}

export const CompareBanner = ({ onClick }: ICompareBannerProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['content-container']}>
        <div className={styles['text-container']}>
          <UIHeading1>ЖК познаются в сравнении</UIHeading1>
          <Body1>Цены, метраж, инфраструктура: покажем всё важное</Body1>
        </div>
        <Button onClick={onClick} maxWidth={216}>
          Как работает сравнение
        </Button>
      </div>

      <div className={styles['image']} aria-hidden="true" />
    </div>
  );
};
